// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import Vuex from 'vuex';
import VueRouter from "vue-router";
import App from "./App";
import axios from 'axios';

// router setup
import routes from "./routes/routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import Notifications from "./components/NotificationPlugin";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

Vue.prototype.$Chartist = Chartist;
Vue.prototype.$URL = process.env.API_URL;

Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);

import createStore from './store';
const store = createStore();

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

function setupAuthRefresh() {
  return new Promise((resolve) => {
    authRefresh(true).finally(() => {
      setInterval(authRefresh, 60 * 1000);
      resolve();
    });
  });
}

function authRefresh(skipStateCheck) {
  if (store.state.user || skipStateCheck) {
    return axios.get('/api/login')
    .then((loginResponse) => {
      store.commit('updateUser', loginResponse.data);
    }).catch(() => {
      store.commit('logout', 'clear');
      if (!routeAllowed(router.currentRoute)) {
        router.replace('Signin');
      }
    });
  } else {
    return Promise.reject();
  }
}

function routeAllowed(route) {
  const requiresAuth = route.matched.some((record) => record.meta.requiresAuth);
  return (!requiresAuth || store.state.user);
}

function routePaid(route) {
  const requiresPaid = route.matched.some((record) => record.meta.requiresPaid);
  return (!requiresPaid || store.state.isPaid)
}

setupAuthRefresh()
.then(() => {
  router.beforeEach((to, from, next) => {
    if (routeAllowed(to)) {
      if (routePaid(to)) {
        next();
      } else {
        next('/payment');
      }
    } else {
      next({
        path: '/signin',
        query: { redirect: to.fullPath}
      });
    }
  });

  const EventBus = new Vue();

  Object.defineProperties(Vue.prototype, {
    $bus: {
      get: () => EventBus
    }
  });

  new Vue({
    el: "#app",
    data: {
      Chartist: Chartist
    },
    render: h => h(App),
    store,
    router
  });
});  




// WEBPACK FOOTER //
// ./src/main.js